import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import './reservedPlaceTypeChart.scss';

import HistoricReservationService from '../historicReservationService';
import ReservationInsightsFilter from '../../interfaces/reservationInsightsFilter';
import LanguageProvider from '@/providers/languageProvider';
import Colors from '@/styles/colors';
import ChartUtils from './chartUtils';
import { SeriesData } from './reservedPeriodChart';
import ActuallyCenteredLoader from '@/components/loaders/actuallyCenteredLoader';

interface ChartProps {
    id: string;
    filter: ReservationInsightsFilter;
}

export interface LocationSeriesData {
    label: string;
    value: number;
}

const ReservedPlaceTypeChart: React.FC<ChartProps> = (props) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [series, setSeries] = useState<LocationSeriesData[]>([]);

    const historicReservationService = new HistoricReservationService();

    useEffect(() => {
        setSeries([]);
        setLoading(true);
        historicReservationService.getPlacePlaceTypePercentage(props.filter).then(response => {
            setSeries(response.map(item => ({
                label: item.placeType,
                value: item.percentage
            })));
            setLoading(false);
        });
    }, [props.filter.triggerUpdate]);

    return <div className="widget-reserved-placetype">
        {!loading &&
            <HighchartsReact
                id={props.id}
                highcharts={Highcharts}
                options={chartOptions(series)} />
        }
        {(loading && <ActuallyCenteredLoader />)}
    </div>;
};

export default ReservedPlaceTypeChart;

const chartOptions = (data: SeriesData[]): Highcharts.Options => ({
    chart: {
        type: 'bar'
    },
    title: { ...ChartUtils.getTitle(LanguageProvider.getTranslation("pages.realestateutilization.charts.reservedplacetypechart.title")), align: 'left', x: 0 },
    xAxis: {
        min: 0,
        categories: data.map(d => `${d.label}`),
        title: {
            text: '',
        },
        scrollbar: {
            enabled: true,
        },
        lineWidth: 0,
        labels: {
            style: {

            },
            useHTML: true,
            formatter: function (): string {
                return `<span class="locationbarchart-custom-label">${this.value}</span>`;
            }
        },
    },
    yAxis: {
        min: 0,
        max: 100,
        title: {
            text: '',
        },
        tickInterval: 25,
        labels: {
            formatter: function (): string {
                return `${this.value}%`;
            }
        }
    },
    series: [
        {
            type: 'bar',
            data: data.map(d => Math.round(d.value)),
            showInLegend: false,
            color: Colors.shakespeare_blue,
            pointPadding: 0.04,
            groupPadding: 0.1,
            dataLabels: {
                enabled: true,
                format: '{point.y}%'
            }
        },
    ],
    tooltip: {
        formatter: function () {
            return `<b>${this.key}</b>: ${this.y}%`;
        }
    },
    credits: {
        enabled: false
    },
    accessibility: {
        enabled: false
    },
    lang: ChartUtils.getLanguageOptions(),
    exporting: ChartUtils.getExportingOptions(),
});
